
export class Halcom{
    constructor(){}

    RacunZaduzenja: string = null;
    RacunOdobrenja: string = null;
    PozivNaBrojOdobrenja: string = null;
    SifraPlacanja: string = null;
    Svrha: string = null;
    Duguje: number = null;
    Potrazuje: number = null;

    DugujeText: string = null;
    PotrazujeText: string = null;

    Deserialize(prviRed: any, input: string){
        this.RacunZaduzenja = this.pronadji(prviRed,input,"Br. računa");
        this.RacunOdobrenja = this.pronadji(prviRed,input,"Račun partnera");
        this.PozivNaBrojOdobrenja = this.pronadji(prviRed,input,"Poziv na broj odobrenja");
        this.SifraPlacanja = this.pronadji(prviRed,input,"Oznaka vrste posla");
        this.Svrha = this.pronadji(prviRed,input,"Svrha");
        // this.Duguje = parseFloat(this.pronadji(prviRed,input,"Iznos zaduženja").split(',').join('.'));
        // this.Potrazuje = parseFloat(this.pronadji(prviRed,input,"Iznos odobrenja").split(',').join('.'));

        this.DugujeText = this.pronadji(prviRed, input, "Iznos zaduženja");
        this.PotrazujeText = this.pronadji(prviRed, input, "Iznos odobrenja");

        this.Duguje = this.parseIznos(this.DugujeText);
        this.Potrazuje = this.parseIznos(this.PotrazujeText);
        return this;
    }

    pronadji(prviRed: any, input:string, tag: string){
        var inputRed = input.split('#');
        var vrati = "";
        for(var i = 0; i < prviRed.length; i++){
            if (prviRed[i]==tag)
            {
                vrati = inputRed[i];               
                return vrati;
               
            }
        }
    }

      private parseIznos(value: string): number {
    if (!value) return 0;
    // briše tačke i menja zarez u tačku
    const clean = value.replace(/\./g, "").replace(",", ".");
    const num = parseFloat(clean);
    return isNaN(num) ? 0 : num;
  }

}